import React from 'react';
import QSightHorizontalStackedBarChart from '../shared/QSightStackBar/QSightHorizontalStackedBarChart';

const jsonData = [
    {
        hospital: 'Hospital A',
        Cardiology: 15,
        Neurology: 20,
        Oncology: 7,
        Pediatrics: 3,
        Ophthalmology: 4,
        Dermatology: 2,
    },
    {
        hospital: 'Hospital B',
        Cardiology: 8,
        Neurology: 23,
        Oncology: 3,
        Pediatrics: 6,
        Ophthalmology: 11,
        Dermatology: 2,
    },
    {
        hospital: 'Hospital C',
        Cardiology: 11,
        Neurology: 2,
        Oncology: 17,
        Pediatrics: 13,
        Ophthalmology: 3,
        Dermatology: 11,
    },
    {
        hospital: 'Hospital D',
        Cardiology: 18,
        Neurology: 3,
        Oncology: 13,
        Pediatrics: 9,
        Ophthalmology: 2,
        Dermatology: 4,
    },
    {
        hospital: 'Hospital E',
        Cardiology: 7,
        Neurology: 10,
        Oncology: 7,
        Pediatrics: 6,
        Ophthalmology: 5,
        Dermatology: 2,
    }
];

const HorizontalStackedBarChartDemo: React.FC = () => {

    return (
        <div>
            <QSightHorizontalStackedBarChart data={jsonData} categoryKey="hospital" />
        </div>
    );
};

export default HorizontalStackedBarChartDemo;
